// Empty polyfill replacement for modern browsers
// This file replaces Next.js polyfills since we target modern browsers only
const emptyPolyfill = {};
export default emptyPolyfill;
